import React, { useContext } from "react";
import { useFormContext } from "react-hook-form";
import { mapFormError } from "../../mappers/form-error-mapper";
import { CalculatorQuestion } from "../../models/CalculatorStep";
import { CalculatorTranslations } from "../../models/CalculatorTranslations";
import { FamilyFormState } from "../../models/FamilyFormState";
import Form from "react-bootstrap/Form";
import { useInfoPanel } from "./InfoPanel";

export type QuestionInputProps = {
  question: CalculatorQuestion;
  translations: CalculatorTranslations;
};

export const QuestionInput: React.FC<QuestionInputProps> = ({
  question,
  translations,
}) => {
  const {
    register,
    getValues,
    formState: { errors },
  } = useFormContext<FamilyFormState>();

  const infoPanel = useInfoPanel();

  const label = (
    <div className="d-flex align-items-center">
      {question.title}
      {!!question.explanation && (
        <button
          type="button"
          className="py-0 btn btn-link text-underline font-weight-light"
          onClick={() => infoPanel.setItem({
            title: question.title || "",
            description: question.explanation || "",
          })}
        >
          {translations.Explanation}
        </button>
      )
      }
    </div >
  );

  if (question.input === "date") {
    return (
      <div className="form-group">
        <label htmlFor={question.field}>{label}</label>
        <Form.Control
          id={question.field}
          isInvalid={!!errors[question.field]}
          type="date"
          {...register(question.field, { required: true })}
        />
        {errors[question.field] && (
          <div>
            <span className="text-red text-small mb-3">
              {mapFormError(errors[question.field]?.type, translations)}
              <br />
            </span>
          </div>
        )}
      </div>
    );
  }

  if (question.input === "string") {
    return (
      <div className="form-group">
        <label htmlFor={question.field}>{label}</label>
        <input
          id={question.field}
          className={
            "form-control" + (errors[question.field] ? " is-invalid" : "")
          }
          {...register(question.field, { required: true })}
        />
        {errors[question.field] && (
          <div>
            <span className="text-red text-small mb-3">
              {mapFormError(errors[question.field]?.type, translations)}
              <br />
            </span>
          </div>
        )}
      </div>
    );
  }

  if (!question.input || question.input === "option") {
    return (
      <div className={`clear-float form-group d-flex flex-column`}>
        {question.title && <div className="label">{label}</div>}
        {question.options.map((option) => {
          // watch(question.field)
          return (
            <label
              className={`${option.value === getValues(question.field)
                ? "btn-outline-primary"
                : "btn-outline-brown-10"
                } btn custom-control custom-radio text-black text-left pl-5 mr-lg-3`}
              htmlFor={question.field + "_" + option.value}
              key={option.text}
            >
              <input
                className="custom-control-input"
                type="radio"
                id={question.field + "_" + option.value}
                value={option.value}
                {...register(question.field, { required: true })}
              />
              <span className="custom-control-label">{option.text}</span>
            </label>
          );
        })}
        {errors[question.field] && (
          <div>
            <span className="text-red text-small mb-3">
              {mapFormError(errors[question.field]?.type, translations)}
              <br />
            </span>
          </div>
        )}
      </div>
    );
  }

  throw new Error("Unrendered question:" + JSON.stringify(question, null, 2));
};
